export default "__VITE_ASSET__CmY$MIos__"